import { configureStore } from '@reduxjs/toolkit';
import RootReducer from './reducer';

export default configureStore({
  reducer: RootReducer,
  devTools: process.env.NODE_ENV === 'development',
});

export type RootState = ReturnType<typeof RootReducer>;
